module.exports = __webpack_public_path__ + "img/logo.3eaa2b82.png";